import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "@CubeComponents/constants/globalFunctions";
import axiosWrapper from "../services/axiosWrapper";
import { CONSTANTS } from "@CubeComponents/constants/globalVariable";
import { formCategories } from "@Helpers";
import {
  setEntityListAction,
  setCategoryListAction,
  setPortalUserPermissionAction,
  getPortalUserListAction,
  getPortalUserCountAction,
  setPortalStatusDataAction,
  setPortalDataAction,
  mergePortalDataAction,
  setPortalEntityListAction,
  setPortalCategoryListAction,
  getDsrDataAction,
  getPortalSettingAction,
} from "../reducers/portalSetting";

export function setSettingContent(data: any) {
  return {
    type: "SET_SETTING_CONTENT",
    data,
  };
}

export const setEntityList = setEntityListAction;

export const setCategoryList = setCategoryListAction;
export function setStatusData(data: any) {
  return {
    type: "SET_STATUS_LIST",
    data,
  };
}

export const setPortalUserPermission = setPortalUserPermissionAction;

export const getPortalUserList = getPortalUserListAction;

export const getPortalUserCount = getPortalUserCountAction;

export const setPortalStatusData = setPortalStatusDataAction;

export const setPortalData = setPortalDataAction;

export const mergePortalData = mergePortalDataAction;

export const setPortalEntityList = setPortalEntityListAction;
export const setPortalCategoryList = setPortalCategoryListAction;

export const getDsrData = getDsrDataAction;

export const getPortalSetting = getPortalSettingAction;

export async function customModuleController(data: any) {
  const responseData = await axiosWrapper.post(`${getBackendUrl()}/portal/customModuleController`, data);
  return responseData;
}

export function getPortalData() {
  return async (dispatch: any) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/portal/getPortalData`, {
      value: {
        where: [
          {
            isComplex: false,
            field: "frontendUrl",
            operator: "equal",
            value: window.location.host,
          },
        ],
      },
    });
    const portalData = response.data.result[0];

    dispatch(
      setPortalData({
        ...portalData,
        logoUrl: getUrlForImage({ id: portalData?._id }, CONSTANTS.PORTAL),
        signUpLogoUrl: getUrlForImage({ id: portalData?._id }, CONSTANTS.SIGNUP),
      }),
    );
  };
}

export function getPortalUsedSeats(data: any) {
  return async (dispatch: any) => {
    const response = await axiosWrapper.post(`${getBackendUrl()}/portal/getPortalUsedSeats`, data);

    const mergedData = {
      usedProSeats: 0,
      usedLiteSeats: 0,
    };

    response.data.result.forEach((data: any) => {
      if (data.roleName == "PORTAL_GUEST") {
        mergedData.usedLiteSeats = mergedData.usedLiteSeats + data.count;
      } else {
        mergedData.usedProSeats = mergedData.usedProSeats + data.count;
      }
    });

    dispatch(mergePortalData(mergedData));
  };
}

// updateProjectRolePermission
export function changePortalRolePermission(data: any) {
  return () => {
    axiosWrapper
      .post(`${getBackendUrl()}/portal/changePortalRolePermission`, data)
      .then((response) => {
        if (response.data.status) {
          // console.log()
        }
      })
      .catch((err) => console.log("Error in changePortalRolePermission ", err));
  };
}

export function addStatusToPortal(data: any) {
  return () => {
    axiosWrapper.post(`${getBackendUrl()}/portal/savePortalStatus/`, data);
  };
}

export function getPortalUserDetails(data: any) {
  return (dispatch: any) => {
    axiosWrapper.post(`${getBackendUrl()}/portal/getPortalUsers`, data).then((response) => {
      if (response && response.status) {
        dispatch(getPortalUserList(response.data.result));
        dispatch(getPortalUserCount(response.data.count));
      }
    });
  };
}

export function addUserToPortal(data: any) {
  return (dispatch: any) => {
    axiosWrapper.post(`${getBackendUrl()}/portal/addUserToPortal`, data).then((response) => {
      if (response.data.status) {
        dispatch(setPortalUserPermission(response.data.data));
      }
    });
  };
}

export async function changePortalRole(data: any) {
  const response = await axiosWrapper.post(`${getBackendUrl()}/portal/changeUserPortalProfile`, data);
  return response.data;
}

export function getPortalStatusData(data: any) {
  return (dispatch: any) => {
    axiosWrapper.put(`${getBackendUrl()}/portal/getPortalStatus`, data).then((response) => {
      if (response.data.status) {
        dispatch(setPortalStatusData(response.data.data));
      }
    });
  };
}

export function getAllPortalEntity() {
  return (dispatch: any) => {
    axiosWrapper.get(`${getBackendUrl()}/portal/getPortalEntityList`).then((response) => {
      if (response.data.status) {
        dispatch(setPortalEntityList(response.data.data));
      }
    });
  };
}

export function getAllPortalCategories() {
  return (dispatch: any) => {
    axiosWrapper.get(`${getBackendUrl()}/resourceStatus/getResourceStatusCategory`).then((response) => {
      if (response.data.status) {
        dispatch(setPortalCategoryList(response.data.data));
      }
    });
  };
}

export function fetchDSRData(data: any) {
  return async (dispatch: any) => {
    axiosWrapper.post(`${getBackendUrl()}/dsr/getDsrData`, data).then((res) => {
      if (res.data.status) {
        dispatch(getDsrData(res.data.result));
      }
    });
  };
}

export const saveAddEditCostDb = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/saveDsrData`, data);
  return response;
};

export const deleteCostDb = async (ids: any) => {
  const data = {
    action: "remove",
    key: ids,
  };
  const response = await axiosWrapper.post(`${getBackendUrl()}/dsr/getDsrData`, data);
  return response;
};

export const updateGroupsData = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/groups/updateGroupsData`, data);
  return response;
};

export const getProjectFormTemplate = async () => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/portal/getFormTemplate`, {
    resourceType: formCategories.projects,
  });
  return response;
};

export const projectTemplateData = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projectTemplates/projectTemplateData`, data);
  return response;
};

export const spaceDataInProjectTemplate = async (data: any) => {
  const response = await axiosWrapper.post(`${getBackendUrl()}/projectTemplates/spacesDataInProjectTemplate`, data);
  return response;
};
